// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import Vuex from 'vuex'
Vue.use(Vuex);

import axios from 'axios'
Vue.prototype.$axios = axios;
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
    // chrome
    document.body.scrollTop = 0
        // firefox
    document.documentElement.scrollTop = 0
        // safari
    window.pageYOffset = 0
        // console.log("路由跳转")
        // $(".v-modal").style.zIndex = "30 !important"

});



import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import "./assets/css/commint.css"
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import VueQriously from 'vue-qriously';
Vue.use(VueQriously);
import AMap from 'vue-amap';
Vue.use(AMap);

import echarts from 'echarts'
Vue.prototype.$echarts = echarts
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, { ak: '' })


var admincrm = sessionStorage.getItem('admincrm');
if (admincrm) {
    axios.defaults.headers.common['admin'] = admincrm;
} else {
    axios.defaults.headers.common['admin'] = '';
}
var appid = sessionStorage.getItem('appid');
if (appid) {
    axios.defaults.headers.common['appid'] = appid;
} else {
    axios.defaults.headers.common['appid'] = '';
}

axios.defaults.headers.common['version'] = 'v1';
axios.defaults.headers.common['fromsource'] = 6;
axios.defaults.headers.common['device'] = 'ADMIN';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
Vue.config.productionTip = false

const Module = {
    state: {
        // 正式
        img_url: "", //图片前缀

        upload: process.env.VUE_APP_UPLOAD_API, //图片上传地址
        p_url: process.env.VUE_APP_BASE_API, // 接口前缀,

        headerappid: {
            appid: window.sessionStorage.getItem('appid'),
        },
    },
}

/* eslint-disable no-new */
const store = new Vuex.Store(Module);
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js